import { IS_PWA } from 'react-easyrocket';

/** В PWA выполняет редирект на тот же адрес, подставляя /pwa,
 * чтобы попасть в правильный basename. Это нужно если вход в PWA
 * происходит не по дефолтной ссылке, например при возврате с
 * регистрации через сторонний сервис.
 * Важно чтобы в проекте не было ни одной страницы, адрес которой начинается
 * со слова pwa - лучше всего при добавлении этой функции переименовать
 * страницу с инструкцией по установке приложения в /install-app например.
 */
export const checkAndSetPwaBasename = () => {
  if (IS_PWA && !location.pathname.startsWith('/pwa')) {
    location.replace('/pwa' + location.pathname + location.search);
  }
};
